import { combineReducers } from 'redux'

import { ANALYSES_STORE_ID } from './analyses/analyses.types'
import { analysesReducer } from './analyses/reducers'
import { dealsReducer } from './deals/reducers'
import { DEALS_STORE_ID } from './deals/types'
import { investorChecksReducer } from './investorChecks/reducers'
import { INVESTOR_CHECKS_STORE_ID } from './investorChecks/types'
import { organizationsReducer } from './organizations/reducers'
import { ORGANIZATIONS_STORE_ID } from './organizations/types'
import { peopleReducer } from './people/reducers'
import { PEOPLE_STORE_ID } from './people/types'
import { DashboardDataState } from './types'

export const dashboardDataReducer = combineReducers<DashboardDataState>({
  [ORGANIZATIONS_STORE_ID]: organizationsReducer,
  [ANALYSES_STORE_ID]: analysesReducer,
  [INVESTOR_CHECKS_STORE_ID]: investorChecksReducer,
  [DEALS_STORE_ID]: dealsReducer,
  [PEOPLE_STORE_ID]: peopleReducer,
})
